import { CurrencyContextProvider } from './currencyProvider'
import { AuthContextProvider } from './authProvider'
import { FavouritesContextProvider } from './favouritesProvider'
import { ModalContextProvider } from './modalProvider'
import { SearchContextProvider } from './SearchContext'
import { useState, useEffect } from 'react'
import { ResponsiveProvider } from './ResponsiveContext'
const Providers = ({ children }) => {
  const [hydrated, setHydrated] = useState(false)

  useEffect(() => {
    setHydrated(true) // Run only after hydration
  }, [])

  return (
    <CurrencyContextProvider>
      <AuthContextProvider>
        <SearchContextProvider>
          <FavouritesContextProvider>
            <ModalContextProvider>
              <ResponsiveProvider>
                {hydrated ? children : null}
              </ResponsiveProvider>
            </ModalContextProvider>
          </FavouritesContextProvider>
        </SearchContextProvider>
      </AuthContextProvider>
    </CurrencyContextProvider>
  )
}

export default Providers
